export default __webpack_public_path__ + "static/media/JUNE2022.20798d13.png";